import { Component, ElementRef, OnInit} from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import {Location} from '@angular/common';
import { ErrorType } from 'src/app/enums/error-type.enum';

@Component({
  selector: 'fury-user-review-add-edit',
  templateUrl: './user-review-add-edit.component.html',
  styleUrls: ['./user-review-add-edit.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class UserReviewAddEditComponent implements OnInit {

  userForm!:FormGroup;
  adminTypeList!: any;
  hide:boolean = true;
  reviewId!:string;
  reviewData:any;
  constructor(
    private apiService: ApiService,
    public location: Location,
    private activateRoute: ActivatedRoute
  ) { 
    this.reviewId = this.activateRoute.snapshot.params["id"];
    if(this.reviewId){
      this.getReviewDetails();
    }
  }

  ngOnInit(): void {
    this.formInit();
  }
  formInit(){
    this.userForm = new FormGroup({
      reviewFrom: new FormControl('', [Validators.required]),
      userName: new FormControl('', [Validators.required]),
      rating: new FormControl('', [Validators.required, Validators.min(0), Validators.max(5)]),
      userLocation: new FormControl('', [Validators.required]),
      reviewText: new FormControl('', [Validators.required]),
    })
  };
  getReviewDetails(){
    this.apiService.get(`admin/user-review/get-user-review/${this.reviewId}`).subscribe((res: any)=>{
      if(res.body){
        this.reviewData = res?.body?.userReview;
        this.userForm.patchValue(res?.body?.userReview);
      }
    })
  };
  addReview(){
    if(this.userForm.valid){
      if(!this.reviewId){
        this.apiService.post('admin/user-review/create-user-review', this.userForm.value).subscribe((res: any)=>{
          if(res){
            this.apiService.alert(res?.body?.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          this.apiService.alert(err.message, ErrorType.Error);
        });
      } else {
        this.apiService.patch(`admin/user-review/update-user-review/${this.reviewId}`, this.userForm.value).subscribe((res: any)=>{
          if(res){
            this.apiService.alert(res?.body?.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          this.apiService.alert(err.message, ErrorType.Error);
        });
      }  
    } else {
      this.userForm.markAllAsTouched();
    }
  };
  restrictSpace(event: any) {
    if (event.target.value.match(/\s/g)) {
      event.target.value = event.target.value.replace(/\s/g, '');
    }
  }


}
